import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { GridStack } from "gridstack";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../DMSHeader/DMSHeader";
import UserTaskTable from "./UserTaskTable/UserTaskTable";
import { useTranslation } from "react-i18next";

const UserTaskManagement = (props) => {
  const { t } = useTranslation();
  const userTaskTableRef = useRef(); // Create ref for UserTaskTable

  useEffect(() => {
    GridStack.init();
  }, []);

  const handleRefreshDailyTasks = () => {
    if (userTaskTableRef.current) {
      userTaskTableRef.current.refreshTaskList(); // Call the exposed function
    }
  };

  const location = useLocation();
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={
            <div className="d-flex justify-content-between align-items-center">
              <span class="col-auto me-auto">{t("task_management_header")}</span>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleRefreshDailyTasks();
                }}
                style={{
                  background: "#18A3A0", // Blue background
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                  marginLeft: "10px",
                  padding: "4px 8px",
                  borderRadius: "4px",
                }}
                title={
                  t("refresh_daily_tasks_tooltip") || "Refresh Daily Tasks"
                }
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </button>
            </div>
          }
          showdownload={true}
          fileName="TaskManagement.csv"
          showmenu={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 11,
      id: 2,
      component: <UserTaskTable ref={userTaskTableRef} />, // Pass the ref to UserTaskTable
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default UserTaskManagement;
